/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Exec_AutopilotInputs */

const en_inbox_exec_autopilot = /** @type {(inputs: Inbox_Exec_AutopilotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep going`)
};

const id_inbox_exec_autopilot = /** @type {(inputs: Inbox_Exec_AutopilotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalan terus`)
};

/**
* | output |
* | --- |
* | "Keep going" |
*
* @param {Inbox_Exec_AutopilotInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_exec_autopilot = /** @type {((inputs?: Inbox_Exec_AutopilotInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Exec_AutopilotInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_exec_autopilot(inputs)
	return en_inbox_exec_autopilot(inputs)
});